import { formatNumber } from "../modules/formatNumber";
import { counterAnimation } from "../modules/counterAnimation";

export function eventWelcome(){
    let cardAchievements=document.querySelectorAll('.card-achievement');
    cardAchievements.forEach((card,index)=>{
        let cardAchievementElm=card.querySelector('.card-achievement__value');
        let cardAchievementValue=parseInt(cardAchievementElm.textContent);
        let cardAchievementValueFormatted=formatNumber(cardAchievementValue);
        cardAchievementElm.innerHTML=cardAchievementValueFormatted;
    })

    counterAnimation('.events-welcome__reward','.number-value')
}